import OverallAccountBalance from "../accounts/overallAccountBalance/OverallAccountBalance";
import DashboardButton from "./DashboardButton";
import DashboardGrid from "./DashboardGrid";
import YourProposedWorksCard from "./Cards/YourProposedWorksCard";
import YourNewsCard from "./Cards/YourNewsCard";
import YourDocumentsCard from "./Cards/YourDocumentsCard";
import YourCasesCard from "./Cards/YourCasesCard";
import "./Dashboard.scss";
import { useSelector } from "react-redux";
import { selectGlobalSettings } from "app/modules/system/settings/ClientPortalSettingsSlice";
import DashboardIntroductionMessage from "./DashboardIntroductionMessage/DashboardIntroductionMessage";

// Temporary background elements image
const Dashboard = () => {
  const globalSettings = useSelector(selectGlobalSettings);

  const cards: JSX.Element[] = [];
  if (globalSettings.showDevelopmentNews) {
    cards.push(<YourNewsCard key={0} />);
  }
  if (globalSettings.showDocuments) {
    cards.push(<YourDocumentsCard key={1} />);
  }
  if (globalSettings.showProposedWorks) {
    cards.push(<YourProposedWorksCard key={2} />);
  }
  if (globalSettings.showCases) {
    cards.push(<YourCasesCard key={3} />);
  }

  const buttons = [
    <DashboardButton
      key={0}
      text="Explore My Account"
      link="/Accounts"
      data-test-id="dashboard__explore-my-account-link"
    />,
  ];
  if (globalSettings.showJobs) {
    buttons.push(
      <DashboardButton
        key={1}
        text="View Development Jobs"
        link="/Jobs"
        data-test-id="dashboard__view-development-jobs-link"
      />
    );
  }
  if (globalSettings.showPayments) {
    buttons.push(
      <DashboardButton
        key={2}
        text="Make A Payment"
        link="/Payments/PayNow"
        data-test-id="dashboard__make-a-payment-link"
      />
    );
  }
  if (globalSettings.showMeetings) {
    buttons.push(
      <DashboardButton
        key={3}
        text="View Upcoming Meetings"
        link="/Meetings"
        data-test-id="dashboard__view-upcoming-meetings-link"
      />
    );
  }
  buttons.push(
    <DashboardButton key={4} text="Add An Account" link="/AddAccount" data-test-id="dashboard__add-an-account-link" />
  );
  if (globalSettings.showDevelopmentInfo) {
    buttons.push(
      <DashboardButton
        key={5}
        text="View Development Information"
        link="/DevelopmentInfo"
        data-test-id="dashboard__view-development-information-link"
      />
    );
  }
  if (globalSettings.showCreditControl) {
    buttons.push(
      <DashboardButton
        key={6}
        text="View Credit Control"
        link="/CreditControl"
        data-test-id="dashboard__view-credit-control-link"
      />
    );
  }

  return (
    <div className="d-flex" style={{ maxWidth: "1000px" }}>
      <div className="container">
        <div className="row mb-6">
          <div className="col-12">
            <DashboardIntroductionMessage />
            <OverallAccountBalance />
            <DashboardGrid cards={cards} buttons={buttons} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
